export default "__VITE_ASSET__Bm09L7cr__"